<div class="flex w-full items-center justify-center ticket text-sm">
    <div class="w-full rounded-lg bg-white px-3 pt-8 shadow-lg">

        <div class="flex flex-col justify-center items-center gap-0 text-sm">
            <div class=" flex flex-col justify-center items-center pb-1">
                <h4 class="font-semibold text-center">{{data.stationName}}</h4>
                <p class="flex">
                    <span class="font-semibold mr-2">RFC: </span>
                    <span>{{data.stationRFC}}</span>
                </p>
                <p class="flex ">
                    <span class="font-semibold mr-2">SIIC:</span>
                    <span>{{data.stationSIIC}}</span>
                </p>
            </div>
        </div>

        <div class=" border-b border border-dashed"></div>

        <div class="flex flex-col justify-center items-center gap-0">
            <div class="text-center">{{data.identification}}</div>
            <div class="text-center">{{data.user}}</div>
            <div class="flex items-center text-center">
                <span class="font-semibold mr-2">Placas: </span>
                <span>{{data.plates}}</span>
            </div>

            <div class="flex items-center text-center">
                <span class="font-semibold mr-2">Unidad: </span>
                <span>{{data.card}}</span>
            </div>
            <div class="flex items-center text-center">
                <span class="font-semibold mr-2">Cuenta: </span>
                <span>{{data.clientNumber}} - {{data.card}}</span>
            </div>
            <div class="flex items-center text-center">

                <span>{{data.date|date:'dd/MM/YYYY hh:mm a' }} - T{{data.shift}}</span>
            </div>
            <div class="flex items-center text-center">
                <span class="font-semibold mr-2">No. Ticket: </span>
                <span>{{data.secuence}} </span>
            </div>
            <div class="flex items-center text-center">
                <span class="font-semibold mr-2">Bomba: </span>
                <span>{{data.pump}} {{data.productDescription}}</span>
            </div>

            <div>

            </div>


        </div>
        <div class="flex flex-col gap-3 pb-6 pt-2 ">
            <table class="w-full text-left">

                <tbody>
                    <tr class="flex">
                        <td class="flex-1">Litros:</td>
                        <td class="min-w-[44px]">{{data.quantity | number}} Lts</td>

                    </tr>
                    <tr class="flex">
                        <td class="flex-1">Precio:</td>
                        <td class="min-w-[44px]">{{data.price | currency}} </td>

                    </tr>
                    <tr class="flex">
                        <td class="flex-1">Importe:</td>
                        <td class="min-w-[44px]">{{data.amount | currency}} </td>

                    </tr>
                    <tr class="flex">
                        <td class="flex-1">Kilometraje:</td>
                        <td class="min-w-[44px]">{{data.kms}} </td>

                    </tr>

                </tbody>
            </table>

            <div class=" border-b border border-dashed"></div>
            <div class="justify-center items-center flex flex-col gap-1">
                <div>{{data.ahorro}}</div>
                <div class="font-semibold">GRACIAS POR SU PREFERENCIA</div>
                <div>CONSERVE ESTE TICKET</div>
                <div>
                    <img [src]="signature&& signature != '' ? 'data:image/png;base64,'+signature : 'data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAQAAAC1HAwCAAAAC0lEQVR42mNkYAAAAAYAAjCB0C8AAAAASUVORK5CYII='"
                        class="max-h-[100px]" />
                </div>
                <div>_________________________</div>
                <div>FIRMA DEL TARJETA HABIENTE</div>
            </div>
        </div>
    </div>
</div>